import React from 'react'
import { DatePicker, Tooltip, Form, Input, Select, Button, Col, Row, Card, } from "antd";
import TextArea from 'antd/es/input/TextArea';


function ScheduledReportsEdit() {
    return (
        <>
            <Form.Item
                label="Schedule Name"
                name="scheduleName"
                rules={[{ required: true }]}
                wrapperCol={{ span: 14 }}

            >
                <Input />

            </Form.Item>

            <h4 style={{ fontSize: 13, marginBottom: 20 }}>Select Report</h4>

            <Form.Item
                label="Saved Reports"
                name="savedReports"
                rules={[{ required: true }]}
                wrapperCol={{ span: 14 }}

            >
                <Select />

            </Form.Item>

            <Form.Item
                label="Format"
                name="format"
                rules={[{ required: true }]}
                wrapperCol={{ span: 14 }}

            >
                <Select />

            </Form.Item>

            <h4 style={{ fontSize: 13, marginBottom: 20 }}>Email Options</h4>

            <Form.Item
                label="Recipents"
                name="recipents"
                rules={[{ required: true }]}
                wrapperCol={{ span: 14 }}

            >
                <Select />

            </Form.Item>

            <Form.Item
                label="Bcc"
                name="bcc"
                wrapperCol={{ span: 14 }}

            >
                <Select />

            </Form.Item>

            <Form.Item
                label="Subject"
                name="subject"
                rules={[{ required: true }]}
                wrapperCol={{ span: 14 }}

            >
                <Input />

            </Form.Item>

            <Form.Item
                label="Message"
                name="message"
                rules={[{ required: true }]}
                wrapperCol={{ span: 14 }}

            >
                <TextArea rows={4} />
                <Button type='link' style={{ paddingLeft: 0 }}>Customize My Signature</Button>

            </Form.Item>

            <h4 style={{ fontSize: 13, marginBottom: 20 }}>Schedule</h4>

            <Form.Item
                label="Start Date"
                name="startDate"
                rules={[{ required: true }]}
                wrapperCol={{ span: 14 }}

            >
                <DatePicker style={{ width: '100%' }} />

            </Form.Item>

            <Form.Item
                label="Frequency"
                name="frequency"
                rules={[{ required: true }]}
                wrapperCol={{ span: 14 }}

            >
                <Select />
                <p style={{ fontSize: 12, marginTop: 12 }}>This report will be emailed every Tuesday in the morning. The next email will be sent on 02/21/2023.
                </p>

            </Form.Item></>
    )
}

export default ScheduledReportsEdit